import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef
} from '@angular/core';
import { ClaimDto } from "../../../../auto-generated-server-dtos/adjuster/claim/claim-dto";
import { RepairDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/repairs/models/repair-dto';
import {AdjusterDto} from "../../../../auto-generated-server-dtos/adjuster/claim/assign-to/adjuster-dto";

@Component({
  selector: 'app-sticky-header',
  templateUrl: './sticky-header.component.html',
  styleUrl: './sticky-header.component.scss'
})
export class StickyHeaderComponent implements OnInit, OnChanges {
  @Input() claimDto: ClaimDto | null = null;
  @Input() repairTotal = 0;
  @Input() busySubmitting = false;
  @Input() repairsDto: RepairDto[] = [];
  @Input() isOpen = true;
  @Output() stickyHeaderStateChange = new EventEmitter<boolean>();
  @Output() updateButtonClicked = new EventEmitter<string>();
  @Input() assignedAdjuster!: AdjusterDto | null;
  @Output() adjusterChanged = new EventEmitter<AdjusterDto>();

  tax = 0;
  pst = 0;
  gst = 0;
  subTotal = 0;
  total = 0;

  constructor(private cdr: ChangeDetectorRef) {
  }
  
  ngOnInit(): void {
    const storedState = localStorage.getItem('stickyHeaderState');
    if (storedState !== null) {
      this.isOpen = JSON.parse(storedState);
      this.stickyHeaderStateChange.emit(this.isOpen);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.repairTotal || changes.manuallyEnteredDeductible) {
      this.calculateTotals();
    }
  }

  setRepairTotal(total: number) {
    setTimeout(() => {
      this.repairTotal = total;
      this.calculateTotals();
    }, 0);
  }

  calculateTotals() {
    this.subTotal = this.repairTotal - (this.claimDto!.manuallyEnteredDeductible ?? this.claimDto!.warranty.deductible!);
    this.subTotal = this.subTotal < 0 ? 0 : this.subTotal;
    this.tax = this.subTotal * this.claimDto!.tax.rate;
    this.total = this.subTotal + this.tax;
    this.cdr.detectChanges();
  }

  updateClaim() {
    this.updateButtonClicked.emit();
  }

  toggleExpandCollapse() {
    this.isOpen = !this.isOpen;
    localStorage.setItem('stickyHeaderState', JSON.stringify(this.isOpen));
    this.stickyHeaderStateChange.emit(this.isOpen);
  }

  setAdjuster($event: AdjusterDto) {
    this.adjusterChanged.emit($event);
  }
}
